export const evaluationRound = (value: number | string | null) => {
  // 小数点第2位で四捨五入
  if (!value) return 0.0;
  value = Number(value);
  return Math.round(value * 10) / 10;
};
